import SIDEBAR_MODEL from "./datamodel/sidebar.model";
import { queryPromise } from "../api";

const isProduction = process.env.NODE_ENV === "production" ? true : false;

const getTransriptsFromClass = function (html, atype, id) {
  const pattern = /<span class=\"(.*?)\"/g;
  let match;
  const transcripts = [];
  while ((match = pattern.exec(html))) {
    const spanclass = match[1];
    if (spanclass.indexOf(atype + "-" + id) >= 0) {
      for (const singleclass of spanclass.split(" ")) {
        if (singleclass.indexOf("id-") >= 0) {
          const singleid = singleclass.substring(3);
          transcripts.push(singleid);
        }
      }
    }
  }
  return transcripts;
};


const _getSeiteNoteTranscriptMapping = function (seite, docs) {
  const out = {};
  const keySet = new Set();
  SIDEBAR_MODEL.forEach(it => {
    it.fudkeys.forEach(key => {
      keySet.add(key);
    });
  });
  const fudkeys = [...keySet];

  docs.forEach(doc => {
    const html98 = doc._source["98_html"];
    const notes = doc._source.notes;
    if (notes) {
      notes.forEach(n => {
        let cat = n.category;
        if (fudkeys.indexOf(cat) < 0) {
          return;
        }
        out[cat] ? null : (out[cat] = []);
        let transcriptIDs = getTransriptsFromClass(
          html98,
          "notice",
          n.ID + " "
        );
        const o = {};
        let ids = [];
        transcriptIDs.forEach(id => {
          o[id] = 1;
        });
        ids = Object.keys(o);
        out[cat].push({
          ID: n.ID,
          ids: ids
        });
      });
    }

    fudkeys.forEach(key => {
      const val = doc._source[key];
      if (val) {
        val.forEach(obj => {
          if (!out[key]) {
            out[key] = [];
          }

          const has = out[key].find(h => h.ID === obj.ID);
          const ids = getTransriptsFromClass(html98, "index", obj.ID);

          if (has) {
            has.ids = has.ids.concat(ids);
          } else {
            out[key].push({
              ID: obj.ID,
              ids: ids
            });
          }
        });
      }
    });
  });
  return out;
};

const initPersonenCollection2 = function (personArr, merzMap) {

  personArr.forEach(person => {
    const merzItems = person.docIds.map(id => merzMap[id]);
    const newMerzItems = new Map();
    merzItems.forEach(it => {
      if (!it) {
        return;
      }

      const m = it.merz;
      const seite = it.seite;
      const sIdx = seite.idx;

      let obj = newMerzItems.get(m.id);
      if (obj) {
        if (!obj.seiten.find(s => s.idx === sIdx)) {
          obj.seiten.push(seite);
        }
      } else {
        newMerzItems.set(m.id, {
          merz: m,
          seiten: [seite]
        });
      }
    });
    const merzItems1 = [...newMerzItems.values()];
    merzItems1.sort((a, b) => {
      a = a.merz.name;
      b = b.merz.name;
      if (a.match(/\d+/) && b.match(/\d+/)) {
        a = getNum({ name: a });
        b = getNum({ name: b });
        if (a > b) {
          return 1;
        } else if (a < b) {
          return -1;
        }
        return 0;
      } else {
        return a.localeCompare(b, 'de');
      }
    });

    person.merzItems1 = merzItems1;
    person.transcripts = [];
  });

  personArr
    .sort((a, b) => {
      return a.content.localeCompare(b.content, 'de')
    });
  return personArr;
}


const getNum = d => {
  let i = parseInt(
    d.name
      .replace("/", ",")
      .split(",")[0]
      .replace(/\D*/, ""),
    10
  );
  if (isNaN(i)) {
    i = 0;
  }
  return i;
};

const initMerzData = function (merzSeitenData) {
  const data = {};
  const docIDmap = new Map();
  merzSeitenData
    .sort((a, b) => a.docID - b.docID)
    .forEach(seite => {
      //manche "Merz 25" manche "Merz25"
      //Fehler in Fud
      const name = seite["Merzname"].replace("Merz ", "Merz");
      data[name] ? data[name].push(seite) : (data[name] = [seite]);
      docIDmap.set(seite.docID + '', seite);
    });

  const merzListe = Object.keys(data).map(name => {
    return {
      name: name,
      seiten: data[name],
      id: name.replace(/\s/g, "")
    };
  });

  // merzListe.push({
  //   name: 'Merz 10',
  //   id: 'Merz10',
  //   seiten: []
  // });
  // merzListe.push({
  //  id: "Merz23",
  //  name: "Merz23",
  //  seiten: []
  // });
  // merzListe.push({
  //   id: "Merz22",
  //   name: "Merz 22",
  //   seiten: []
  // });

  // const imageDziDir = isProduction
  //   ? "http://urts55.uni-trier.de/gan_dev/ksm/image_dzi"
  //   : "static/image_dzi";

    

  const imageDziDir = "static/image_dzi";
  //const imageDziDir = "http://urts55.uni-trier.de/gan_dev/ksm/static/image_dzi"
  merzListe.forEach(merz => {
    let merzName = merz.name;
    if (merz.seiten && merz.seiten[0]) {
      merz.merzNameId = merz.seiten[0].MerzNameID;
    }

    const onePage = {};
    merz.seiten.forEach((d, i) => {
      let imgD;
      let dzidir = imageDziDir;
      if (d.aufseite !== null) {
        imgD = docIDmap.get(d.aufseite + '');
      } else {
        imgD = d;
      }
      let img = imgD["doppelseite"];
      if (img) {
        d["imgDir"] = "doppelseitig";
      } else {
        img = imgD["einzelseite"];
        d["imgDir"] = "einseitig";
      }


      if (!img) {
        return;
      }

      if (onePage[img]) {
        onePage[img].seiteIds.push(d.docID);
        onePage[img].docs.push(d);
        return;
      }

      onePage[img] = {};

      if (merzName.indexOf("Merz") === 0 && merzName !== "Merz25") {
        //merz
        onePage[img]["thumbnailSrc"] = [
          imageDziDir,
          "Thumbnails",
          img.replace(".jpg", ".png")
        ].join("/");
        onePage[img]["deepSrc"] = [
          dzidir,
          img.replace(".jpg", ".png"),
          img.replace(".jpg", "") + ".dzi"
        ].join("/");
      } else if (merzName === "Ursonate") {
        //ursonate
        onePage[img]["thumbnailSrc"] = [
          imageDziDir,
          "Thumbnails",
          "thb",
          img.replace(".jpg", ".png")
        ].join("/");
        onePage[img]["deepSrc"] = [
          dzidir,
          img.replace(".jpg", ".tif"),
          img.replace(".jpg", "").replace(".png", "") + ".dzi"
        ].join("/");
      } else {
        let tbImg = img;
        if (merzName === "Merz25") {
          tbImg = img.replace(".jpg", ".png");
        }
        //merzwerbe
        onePage[img]["thumbnailSrc"] = [
          imageDziDir,
          "Thumbnails",
          "thb",
          tbImg
        ].join("/");
        onePage[img]["deepSrc"] = [
          dzidir,
          img.replace(".jpg", ".png"),
          img.replace(".jpg", "").replace(".png", "") + ".dzi"
        ].join("/");
      }

      let format = d["format"];
      if (format && format.indexOf("x") > 0) {
        format = format.split("x");
        onePage[img].width = parseFloat(
          format[1].replace("cm", "").replace(",", "."),
          10
        );
        onePage[img].height = parseFloat(format[0].replace(",", "."), 10);
      }

      onePage[img].seiteIds = [d.docID];
      onePage[img].docs = [d];
      onePage[img].title = d.title;
    });

    const arr = [];
    for (let k in onePage) {
      arr.push(onePage[k]);
    }
    merz.seiten = arr.sort((a, b) => {
      a = a.docs[0].docID;
      b = b.docs[0].docID;
      if (a - b > 0) {
        return 1;
      } else if (a - b < 0) {
        return -1;
      }
      return 0;
    });
    //set page idx and name

    let isMerzwerbe = false;
    if (!merz.name.match(/^Merz\d*/) && merz.name !== "Ursonate" && !merz.name.match(/Noten/g)) {
      isMerzwerbe = true;
    }

    merz.seiten.forEach((s, i) => {
      s.idx = i;
      let _n = s.docs
        .map(_d => {
          if (isMerzwerbe) {
            return _d.title;
          } else {
            return _d.paginierung ? _d.paginierung : _d["ArtderSeiteText"];
          }
        })
        .join(",");
        if (_n.match(/[^\d\,]/)) {
          s.name = _n;
        } else {
          s.name = "Seite " + _n;
        }

      let _v = s.docs
        .map(_d => {
            return _d.varianteseite ? _d.varianteseite : '';
        })
        .join("");
        if (_v !== '') {
          s.variante = _v;
        } else {
          s.variante = '';
        }

        let _da = s.docs
        .map(_d => {
            return _d.datum ? _d.datum : '';
        })[0];
        if (_da !== '') {
          s.datum = _da;
        } else {
          s.datum = '';
        }

    });
  });

  //defineProperty
  merzListe.forEach(merz => {
    merz._ = {
      einfuehrung: null,
      fetchEifuehrung: false
    };
    Object.defineProperty(merz, "$_einfuehrungDoc", {
      get: () => {
        if (!merz._.fetchEifuehrung) {
          merz._.fetchEifuehrung = true;
          merz.merzNameId &&
            fetchMerzExtendByIdPromise(merz.merzNameId).then(res => {
              if (res.merz && res.merz[0][0]) {
                let docID = res.merz[0][0].docID;
                fechtDocumentById(null, docID).then(d => {
                  if (d && d.doc[0]) {
                    merz._.einfuehrung = d.doc[0];
                  }
                });
              }
            });
        }
        return merz._.einfuehrung;
      }
    });

    merz.seiten.forEach(seite => {
      seite.$_themen = null;
      seite.$_parseMei = false;
      seite._ = {
        mainKommentar: null,
        docInfo: [],
        graphElemente: null,
        attachmentTags: null,
        fetchAttachmentTagsEnd: false,
        fetchMainKommentar: false,
        fetchMerzSeitenInfoStart: false,
        fetchMerzSeitenInfoEnd: false,
        cropImages: {},
        fetchCropImagesEnd: false,
        fetchGraphElemente: false
      };

      Object.defineProperty(seite, "$_mainKommentar", {
        get: () => {
          if (!seite._.fetchMainKommentar) {
            seite._.fetchMainKommentar = true;
            fetchSeiteExtendByIdPromise(null, seite.seiteIds.join(",")).then(
              res => {
                seite._.mainKommentar = res;
              }
            );
          }
          return seite._.mainKommentar;
        }
      });

      Object.defineProperty(seite, "$_fetchCropImagesEnd", {
        get: () => {
          return seite._.fetchCropImagesEnd;
        }
      });

      Object.defineProperty(seite, "$_attachmentTags", {
        get: () => {
          if (!seite._.attachmentTags && seite.docs) {
            seite._.attachmentTags = [];
            seite.docs.forEach(d => {
              if (d.filename) {
                queryPromise("attachment/" + d.filename).then(res => {
                  seite._.attachmentTags.push({
                    docID: d.docID,
                    tag: res.tag
                  });
                  if (seite._.attachmentTags.length === seite.docs.length) {
                    seite._.fetchAttachmentTagsEnd = true;
                  }
                });
              }
            });
          }
          return seite._.attachmentTags;
        }
      });

      Object.defineProperty(seite, "$_fetchAllExtendInfoEnd", {
        get: () => {
          if (
            seite.$_attachmentTags &&
            seite.$_docInfo &&
            seite._.fetchAttachmentTagsEnd &&
            seite._.fetcmerzSeitenDataocInfoEnd &&
            seite.$_graphElemente
          ) {
            return true;
          }
        }
      });

      Object.defineProperty(seite, "$_docInfo", {
        get: () => {
          if (!seite._.fetcmerzSeitenDataocInfoStart) {
            seite._.fetcmerzSeitenDataocInfoStart = true;
            fechtSeiteDocs(null, seite);
          }
          return seite._.docInfo;
        }
      });

      Object.defineProperty(seite, "$_graphElemente", {
        get: () => {
          if (!seite._.fetchGraphElemente) {
            seite._.fetchGraphElemente = true;
            queryPromise("getGraphElementeBySeite/" + seite.seiteIds.join(",")).then(res => {
              seite._.graphElemente = res.transcripts;
            });
          }
          return seite._.graphElemente;
        }
      });
    });
  });

  merzListe.sort((a, b) => {
    a = getNum(a);
    b = getNum(b);
    if (a > b) {
      return 1;
    } else if (a < b) {
      return -1;
    }
    return 0;
  });

  const merzSvgMapping = [
    {
      id: "Merz1",
      svgID: "SVGID_15_"
    },
    {
      id: "Merz2",
      svgID: "SVGID_17_"
    },
    {
      id: "Merz3",
      svgID: "SVGID_29_"
    },
    {
      id: "Merz4",
      svgID: "SVGID_27_"
    },
    {
      id: "Merz5",
      svgID: "SVGID_11_"
    },
    {
      id: "Merz6",
      svgID: "SVGID_19_"
    },
    {
      id: "Merz7",
      svgID: "SVGID_21_"
    },
    {
      id: "Merz8/9",
      svgID: "SVGID_23_"
    }, {
      id: "Merz10",
      svgID: "SVGID_st10_"
    },
    {
      id: "Merz11",
      svgID: "SVGID_25_"
    },
    {
      id: "Merz12",
      svgID: "SVGID_13_"
    },
    {
      id: "Merz13",
      svgID: "SVGID_st131_"
    },
    {
      id: "Merz14,15",
      svgID: "SVGID_1_"
    },
    {
      id: "Merz16/17",
      svgID: "SVGID_3_"
    },
    {
      id: "Merz18/19",
      svgID: "SVGID_5_"
    },
    {
      id: "Merz20",
      svgID: "SVGID_7_"
    },
    {
      id: "Merz21",
      svgID: "SVGID_9_"
    }, {
      id: "Merz22",
      svgID: "SVGID_st22_"
    }, {
      id: "Merz23",
      svgID: "SVGID_st23_"
    },
    {
      id: "Merz24",
      svgID: "SVGID_st241_"
    },
    {
      id: "Merz25",
      svgID: "SVGID_st25_"
    }
  ];

  merzSvgMapping.forEach(a => {
    const merz = merzListe.find(m => m.id === a.id);
    if (merz) {
      merz.svgID = a.svgID;
    }
  });

  return merzListe;
};

const _initDocsTranscripts = function (openedSeite, docs) {
  let out = [];
  docs.forEach((d, idx) => {
    if (!openedSeite.docs[idx]) {
      return;
    }
    let offsetX = parseFloat(openedSeite.docs[idx].doppelseitex);
    let offsetY = parseFloat(openedSeite.docs[idx].doppelseitey);

    d._source.transcript.forEach(tr => {
      if (offsetX > 0 || offsetY > 0) {
        const ulx = parseFloat(tr.ulx) + offsetX;
        const lrx = parseFloat(tr.lrx) + offsetX;
        const uly = parseFloat(tr.uly) + offsetY;
        const lry = parseFloat(tr.lry) + offsetY;
        tr.x = parseFloat(ulx);
        tr.y = parseFloat(uly);
        tr.w = parseFloat(lrx) - parseFloat(ulx);
        tr.h = parseFloat(lry) - parseFloat(uly);
      } else {
        tr.x = parseFloat(tr.ulx);
        tr.y = parseFloat(tr.uly);
        tr.w = parseFloat(tr.lrx) - parseFloat(tr.ulx);
        tr.h = parseFloat(tr.lry) - parseFloat(tr.uly);
      }
    });
    out.push({
      docID: d._id,
      transcripts: d._source.transcript
    });
  });
  return out;
};

export const fechtDocumentById = async function (store, ids) {
  return await queryPromise("document/" + ids);
};

export const fechtSeiteDocs = async function (store, seite) {
  return await queryPromise("document/" + seite.seiteIds.join(",")).then(d => {
    if (d && d.doc && !seite._.fetcmerzSeitenDataocInfoEnd) {
      seite._.docInfo = seite._.docInfo.concat(d.doc);
      seite.$_accoId_transcript_mapping = _getSeiteNoteTranscriptMapping(
        seite,
        d.doc
      );
      seite._.fetcmerzSeitenDataocInfoEnd = true;
      seite.$_allTranscripts = _initDocsTranscripts(seite, d.doc);
    }
    return d;
  });
};

export const fetchMerzAndPersonData = async function ({ state, commit }) {
  let res = await queryPromise("merzperson");

  if (res && res.merzListe) {
    //seiteListe

    const jsonMerzList = res.merzListe;
    const merzListe = initMerzData(jsonMerzList);

    const seiteIdMap = {};
    const texte = [];
    const werbe = [];
    const ursonate = [];
    //merz gruppieren

    merzListe.forEach(merz => {
      if (merz.name.match(/^Merz\d*/)) {
        texte.push(merz);
      } else if (merz.name === "Ursonate" || merz.name.match(/Noten/g)) {
        ursonate.push(merz);
      } else {
        werbe.push(merz);
      }
      merz.seiten.forEach(seite => {
        seite.seiteIds.forEach(id => {
          seiteIdMap[id] = {
            merz: merz,
            seite: seite
          };
        });
      });
    });
    state.texte.merzListe = texte;
    state.werbe.merzListe = werbe;
    state.ursonate_noten.merzListe = ursonate;
    state.ursonate_texte.merzListe = texte.filter(m => m.name === 'Merz24');
    state.personen.collection2 = initPersonenCollection2(res.personen, seiteIdMap);
  }
};

export const fetchMerzExtendByIdPromise = async function (merzId) {
  return await queryPromise("merz/extend/" + merzId);
};

export const fetchSeiteExtendByIdPromise = async function (sotre, seiteIds) {
  let res = await queryPromise("seite/extend/" + seiteIds);
  if (!res.seite || !res.seite[0]) {
    return;
  }
  let merzIds = res.seite[0].map(_seite => _seite.docID);
  if (merzIds.length < 1) {
    return;
  }
  let res2 = await fechtDocumentById(null, merzIds.join(","));
  let out = [];
  res2.doc.forEach(d => {
    out.push(d);
  });
  return out;
};

export const fetchtranscriptCropImg = async function (store, playload) {
  return queryPromise(
    "transcriptCropImg/attachment/download/" + playload.id + "/" + playload.tag
  );
};

export const fetchBibliographie = async function ({ state }) {
  if (!state.bibliographie) {
    let res = await queryPromise("bibliographie");
    state.bibliographie = res.bibliographie;
  }
  return state.bibliographie;
};

export const fetchUrsonate = async function ({ state }) {
  if (!state.ursonateData) {
    let res = await queryPromise("getUrsonate");
    state.ursonateData = res.ursonate;
    state.ursonateData2 = res.ursonate2;
  }
  return state.ursonateData;
};

export const setOSDToolTips = function (store, OSD) {
  const OSDTooltips = store.state.OSDTooltips;
  Object.keys(OSDTooltips).forEach(key => {
    OSD.setString("Tooltips." + key, OSDTooltips[key]);
  });
};



// WEBPACK FOOTER //
// ./src/store/actions.js